export default "__VITE_ASSET__OYHuuY_q__"